module.exports = __webpack_public_path__ + "img/cannon20_icon.79c19b91.png";